import React from 'react';
import styles from './button.scss';
import { gaTracking } from '../../modules/ga';

const sendGAEvent = gaEvent => {
  return () => {
    if (!gaEvent) return;
    gaTracking(gaEvent.event, gaEvent.params);
  };
};

const Button = ({ children, big, link, gaEvent }) => {
  return (
    <a
      className={`${styles.button} ${big ? styles.buttonBig : ''}`}
      href={link}
      onClick={sendGAEvent(gaEvent)}
    >
      <div className={styles.buttonContent}>
        Learn more
        <div className={styles.buttonImg} />
      </div>
    </a>
  );
};

Button.defaultProps = {
  big: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.js